module.exports = __webpack_public_path__ + "img/quantum-tela-app-3-250x174.d6b64e20.png";